export const profilePage = 'settings-account'
export const projectsPage = 'projects'
export const myCompanyPage = 'projects'
export const myTasksPage = 'my-tasks'
export const othersTasksPage = 'others-tasks'

export const mainMenuLocalStorageKey = 'main-menu'

export const eventsFeedPage = 'event-feed'
export const statisticsPage = 'statistics'
export const billingPage = 'billing'
export const partnerPage = 'partner'
export const feedbackPage = 'feedback'
